import { createReducer, on } from '@ngrx/store';
import { ImpersonationActions } from '@ps/auth-data-access';

import { INITIAL_TEMPLATE_STATE } from './template-state.constants';
import { TemplateActions, TemplateApiActions } from './template.actions';

export const templateReducer = createReducer(
  INITIAL_TEMPLATE_STATE,

  on(
    TemplateApiActions.loadTemplatesSuccess,
    (state, { templates, cachedAt }) => ({
      ...state,
      templates,
      templatesCachedAt: cachedAt,
      loadTemplatesError: null,
    }),
  ),

  on(TemplateApiActions.loadTemplatesFailure, (state, { error }) => ({
    ...state,
    templates: [],
    loadTemplatesError: error,
  })),

  on(TemplateActions.createTemplateFolder, (state) => ({
    ...state,
    folderCreationError: null,
    createdFolderId: null,
  })),

  // Invalidate so the reload$ effect's follow-up loadTemplates isn't skipped
  // by the cache gate.
  on(TemplateApiActions.createTemplateFolderSuccess, (state, { folder }) => ({
    ...state,
    createdFolderId: folder.id,
    folderCreationError: null,
    templatesCachedAt: null,
  })),

  on(TemplateApiActions.createTemplateFolderFailure, (state, { error }) => ({
    ...state,
    folderCreationError: error,
    createdFolderId: null,
  })),

  on(
    TemplateApiActions.saveTemplateSuccess,
    TemplateApiActions.updateTemplateSuccess,
    (state) => ({
      ...state,
      templatesCachedAt: null,
      loadTemplatesError: null,
    }),
  ),

  on(TemplateActions.reset, (state) => ({
    ...state,
    folderCreationError: null,
    createdFolderId: null,
  })),

  on(ImpersonationActions.contextSettled, (state) => ({
    ...state,
    templates: INITIAL_TEMPLATE_STATE.templates,
    templatesCachedAt: INITIAL_TEMPLATE_STATE.templatesCachedAt,
    loadTemplatesError: INITIAL_TEMPLATE_STATE.loadTemplatesError,
  })),
);
